import { ChangeEvent, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import { usePromoCodeClaim } from './hooks'
import { useOverlayActions } from '@store'
import { Tooltip } from '@ds'
import { ClaimPromoCodeError } from '@api'


const ERROR_MESSAGES: Record<ClaimPromoCodeError, string> = {
    bad_request: 'promoCode.error.badRequest',
    not_found: 'promoCode.error.notFound',
    user_limit_reached: 'promoCode.error.userLimitReached',
    too_many_requests: 'promoCode.error.tooManyRequests',
}

export const PromoCode = () => {
    const [value, setValue] = useState('')
    const { t } = useTranslation()
    const { setOverlayQueue } = useOverlayActions()

    const { error, claimPromoCode, resetError } = usePromoCodeClaim({
        onSuccess: (data) => {
            if (!data) {
                return
            }
            setOverlayQueue([{
                type: 'currencyReward',
                payload: {
                    description: 'Your reward for using\na promo code',
                    amount: data.score_per_use,
                },
            }])
        },
    })

    const handleClaimPromoCode = useCallback(() => {
        if (!value) {
            return
        }

        claimPromoCode(value)
    }, [claimPromoCode, value])

    const handleInputChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value)
        resetError()
    }, [resetError])

    return (
        <div className={styles.container}>
            <span className={styles.title}>{t('promoCode.activate')}</span>
            <Tooltip tooltipId="promoCodeTooltip" isOpen={Boolean(error)} position='bottom' tooltipContent={<div className={styles.errorMessageContainer}>
                <span className={styles.errorMessage}>
                    {error && t(ERROR_MESSAGES[error])}
                </span>
            </div>}>
                <div className={styles.inputContainer}>
                    <input
                        className={styles.input}
                        placeholder={t('promoCode.input')}
                        value={value}
                        onChange={handleInputChange}
                    />
                    <button className={styles.activateButton} onClick={handleClaimPromoCode}>
                        <span className={styles.activateButtonLabel}>{t('promoCode.redeem')}</span>
                        <div className={styles.activateButtonGlow} />
                    </button>
                </div>
            </Tooltip>
            <span className={styles.claim}>({t('promoCode.claim')})</span>
        </div>
    )
}